<template lang="pug">
  .classifier-form
    e-toolbar(
      :items="items"
      @deleteItems="deleteItems"
      :hideRemoveButton="true"
      :hideAddButton="true"
      :showViewPanel="false"
      :showTotal="true"
      :showYear="true"
      @changeYear="changeYear"
    )
      div(slot="filter-status")
        select.select(v-model='month' @change='changeMonth') )
          option(v-for='month in months' :value="month.value") {{month.name}}
    e-table(
      :items="items"
      @editItem="editItem"
      :showDeleteButton="false"
      :showCheckbox="false"
    )
    router-view
</template>

<script>
import { report } from '@/api/api-endpoints'
import tableMixin from '@/components/table/table-mixin'
import RouteMixin from '@/mixins/route-mixin'
import PermissionMixin from '@/mixins/permission-mixin'
import year from '@/utils/year'

import { months } from './utils'

const currentYear = year.getCurrentYear()
const currentDate = new Date()
const currentMonth = currentDate.getMonth() + 1

export default {
  mixins: [tableMixin, RouteMixin, PermissionMixin],
  data: () => {
    return {
      year: currentYear,
      months: months,
      month: currentMonth,
    }
  },
  methods: {
    getEndpoint() {
      return report.order285({
        query: {
          year: this.year || currentYear,
          month: this.month || currentMonth,
        },
      })
    },
    changeYear(year) {
      this.year = year
      this.reFetchData()
    },
    changeMonth() {
      this.replaceRoute({ month: this.month })
      this.reFetchData()
    },
    checkPermission() {
      if (!this.userCan('generated-waste-amount-read')) {
        this.$router.push({
          name: 'import.importExcel',
          query: {
            fromName: this.$route.name,
            prevRoute: JSON.stringify({
              name: 'geo',
            }),
          },
        })
      }
    },
  },
  created() {
    this.checkPermission()
    if (this.$route.query.month) {
      this.month = this.$route.query.month
    }
    if (this.$route.query.year) {
      this.year = this.$route.query.year
    }
  },
}
</script>
